var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useMemo, useCallback } from 'react';
import { usePage } from '../../../ModulePage';
import { useBlockEdit } from '../../';
import { Content } from '../BlockWrapper';
import { LazyLoadPlaceholder } from '../../../LazyLoadPlaceholder';
import { TextEditor } from '../../../TextEditor';
import { useTheme } from '@web/theme';
import chroma from 'chroma-js';
export var BlockText = memo(function (_a) {
    var text = _a.text, block = __rest(_a, ["text"]);
    var theme = useTheme();
    var pageIsFetching = usePage().pageIsFetching;
    var _b = useBlockEdit(), blockEdit = _b.blockEdit, onBlockChange = _b.onBlockChange;
    var onChange = useCallback(function (value) {
        onBlockChange({ value: value });
    }, [onBlockChange]);
    var value = useMemo(function () { return text; }, [block._id, blockEdit.enabled]);
    var linkColor = (block === null || block === void 0 ? void 0 : block.checkLinkContrast)
        ? chroma.contrast(block.bg || theme.accent3rd.bg, theme.brand.bg) < 4
            ? block.color || theme.accent3rd.txt
            : theme.brand.bg
        : theme.brand.bg;
    return (React.createElement(Content, { id: "BlockTextContent", linkColor: linkColor }, pageIsFetching
        ? React.createElement(LazyLoadPlaceholder, null)
        : React.createElement(TextEditor, { readOnly: !blockEdit.enabled, value: value, onChange: onChange, placeholder: "...", bg: (block === null || block === void 0 ? void 0 : block.bg) || theme.accent3rd.bg, color: (block === null || block === void 0 ? void 0 : block.color) || theme.accent3rd.txt })));
});
